import { Box, Typography } from '@material-ui/core'

import { useStyles } from './styles'

interface MessageProps {
  title?: string
  message?: string
}

export const Message: React.FC<MessageProps> = ({
  title,
  message,
  children,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Typography variant='h2'>{title}</Typography>
      <Box
        flex={1}
        display='flex'
        flexDirection='column'
        justifyContent='center'
        marginX='5rem'
      >
        {children || <Typography>{message}</Typography>}
      </Box>
    </div>
  )
}
